import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';

import { GET_COMMENTLIST,GET_DELETECOMMENT  } from '../../actions';

class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      routelist:''
    };
    
    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };
    this.props.getCommentList(qs.stringify(postobject));
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

   
    componentDidMount() {
      document.title = PageTitle('Comment List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");

     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id
     };
     this.props.getCommentList(qs.stringify(postobject))
   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id         
  };
  //console.log(postObject);
  this.props.getCommentList(qs.stringify(postObject));

} 



   componentWillReceiveProps(Props){
    console.log(Props.commentlist)
    if (Object.keys(Props.commentlist).length > 0) {
      if (Props.commentlist[0]["status"] === "success") {
        this.setState({ totalRecord : Props.commentlist[0].records_count, commentlist: Props.commentlist[0]["commentlist"] });
      }
    }

    if (Props.commentdelete!== undefined && Object.keys(Props.commentdelete).length > 0) {
      if (Props.commentdelete[0]["status"] === "success") {
        this.setState({
          commentlist: Props.commentdelete[0]["commentlist"],
        });
      }

      this.setState({statusmessage: Props.commentdelete[0].message});

            setTimeout(
            function() {
              this.setState({statusmessage:''})
            }
            .bind(this),
            3000
          );
     window.location.reload(); 
    }
     
   }

   deletecomment(id){
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      comment_id  :id
    };
   this.props.getDeleteComment(qs.stringify(postObject));
}

commentlist() {
    var commentlist = this.props.commentlist[0];
    if (commentlist != "undefined" && commentlist != null) {
      if (commentlist.status!== undefined && commentlist.status == "success") {
        if (Object.keys(commentlist).length > 0) {
          const commentlistDetails = commentlist.commentlist.map(
            (commentlist, Index) => {
              let sno = Index+1;
              if(commentlist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
              var istyle = { width: 100};
              return (
                <tr key={commentlist.id}>
                <td>{sno}</td>
                <td>{commentlist.comments}</td> 
                <td>{status}</td>
                  <td className="actiongroup">

                    <Link to={{ pathname: '/comment-edit/'+commentlist.id}} className="" title="Edit">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                    <Link onClick={this.deletecomment.bind(this,commentlist.id)} className="" title="Duplicate">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return commentlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="8" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="8" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="comments" />  
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Comments</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                <div className="add_button">  
                    <a className="add" href='/comment-add'>Add</a> 
                </div>  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
                  <th>Comments</th>
                  <th>Status</th>
                  <th>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.commentlist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    commentlist: state.commentlist,
    commentdelete: state.commentdelete,
   

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
   getCommentList: (formVal) =>{
      dispatch({ type: GET_COMMENTLIST, formVal});
   },
   getDeleteComment: (formPayload) =>{
     dispatch({ type: GET_DELETECOMMENT, formPayload });
   },
   
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));